import React from 'react';
import Agentbox from './Agentbox';
import agentimage1 from '../images/s1.png';
import agentimage2 from '../images/s2.png';
import agentimage3 from '../images/s3.png';


function Agent() {
    return (
        <div className='agent'>
            <div className='a-heading'>
                <h1>Agents</h1>
                <p>The agents we got from our Company!&#9203;</p>
            </div>
            <div className='b-container'>
                <Agentbox image={agentimage1} name='|Contract_Agent_#1|'/>
                <Agentbox image={agentimage2} name='|Contract_Agent_#2|'/>
                <Agentbox image={agentimage3} name='|Contract_Agent_#3|'/>
            </div>
        </div>
    );
}

export default Agent
